import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Minus, Plus } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function ProductDetail() {
  const { id } = useParams();
  const { add } = useCart();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [imgIdx, setImgIdx] = useState(0);

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => setProduct(r.data)).catch(() => setProduct(false));
  }, [id]);

  if (product === null) return <div className="py-32 text-center text-alimi-inkSoft">Caricamento…</div>;
  if (product === false) return (
    <div className="py-32 text-center">
      <div className="font-serif text-3xl mb-4">Prodotto non trovato</div>
      <Link to="/shop" className="btn-outline">Torna allo shop</Link>
    </div>
  );

  const images = product.images?.length ? product.images : [""];

  return (
    <div data-testid="product-page" className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
      <Link to="/shop" className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-alimi-inkSoft hover:text-alimi-ink">
        <ArrowLeft size={14} /> Torna allo shop
      </Link>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mt-8">
        {/* Gallery */}
        <div>
          <div className="aspect-[3/4] bg-alimi-surface2 overflow-hidden">
            {images[imgIdx] ? (
              <img src={images[imgIdx]} alt={product.name} className="w-full h-full object-cover" />
            ) : null}
          </div>
          {images.length > 1 && (
            <div className="flex gap-3 mt-4 overflow-x-auto scrollbar-hide">
              {images.map((src, i) => (
                <button
                  key={i}
                  onClick={() => setImgIdx(i)}
                  className={`w-20 h-24 bg-alimi-surface2 border ${i === imgIdx ? "border-alimi-ink" : "border-transparent"}`}
                  data-testid={`thumb-${i}`}
                >
                  {src && <img src={src} alt="" className="w-full h-full object-cover" />}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Info */}
        <div className="lg:pt-8">
          <div className="overline">{product.category}</div>
          <h1 className="font-serif text-4xl sm:text-5xl mt-4 tracking-tight">{product.name}</h1>
          <div className="text-2xl text-alimi-inkSoft mt-5 font-serif">€ {Number(product.price).toFixed(2)}</div>
          <div className="alimi-divider mt-8" />
          <p className="text-sm text-alimi-inkSoft leading-relaxed mt-8 whitespace-pre-line">
            {product.description || "Pezzo unico realizzato a mano nel nostro atelier."}
          </p>

          <div className="mt-10 space-y-6">
            <div className="flex items-center gap-5">
              <span className="overline">Quantità</span>
              <div className="flex items-center border border-alimi-border">
                <button data-testid="qty-dec" onClick={() => setQty(Math.max(1, qty - 1))} className="p-3 hover:bg-alimi-surface2"><Minus size={14} /></button>
                <span className="px-5 text-sm">{qty}</span>
                <button data-testid="qty-inc" onClick={() => setQty(qty + 1)} className="p-3 hover:bg-alimi-surface2"><Plus size={14} /></button>
              </div>
            </div>
            <button
              data-testid="add-to-cart-btn"
              className="btn-primary w-full sm:w-auto"
              disabled={!product.in_stock}
              onClick={() => add(product, qty)}
            >
              {product.in_stock ? "Aggiungi al carrello" : "Non disponibile"}
            </button>
          </div>

          <div className="mt-14 grid grid-cols-2 gap-6 text-xs text-alimi-inkSoft">
            <div>
              <div className="overline mb-2">Spedizione</div>
              <p>Spediamo in tutta Italia in 3-5 giorni lavorativi.</p>
            </div>
            <div>
              <div className="overline mb-2">Cura</div>
              <p>Lavare a mano in acqua fredda con detergente delicato.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
